import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const InfoTooltip = ({ title }) => (
    <Tooltip title={title} arrow placement="top">
        <IconButton size="small" sx={{ p: 0.25, ml: 0.25, color: 'text.muted' }}>
            <InfoOutlinedIcon sx={{ fontSize: 13 }} />
        </IconButton>
    </Tooltip>
);

export default InfoTooltip;
